import { PermIdentity as PermIdentityIcon } from '@mui/icons-material';

export default function Profile(): JSX.Element {
  return <PermIdentityIcon fontSize="inherit" />;
}
